import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import AppContext from '../../AppContext';
import Card from '../../shared/Card';
import Spinner from '../../shared/Spinner';
import Posts from '../Posts';

const RoomDoesNotExist = () => (
  <Card title="Room Does Not Exist">
    <p>
      Want this room to exist?
      <br />
      Ask for it in <Link to="/r/general">r/general</Link>.
    </p>
  </Card>
);

const DEFAULT_ROOM_ID = 'home';
const Room = (props) => {
  const [room, setRoom] = useState(null);
  const [loading, setLoading] = useState(true);
  const { rooms, user } = useContext(AppContext);

  useEffect(() => {
    if (!rooms) return;
    const roomId = props.match.params.roomId || DEFAULT_ROOM_ID;
    setRoom(rooms[roomId]);
    setLoading(false);
  }, [rooms, props.match.params.roomId]);

  useEffect(() => {
    if (room && room.title) document.title = `${room.title} | xBook`;
  }, [room]);

  if (loading) {
    return (
      <div className="text-center">
        <Spinner size="lg" />
        <div className="mt-2">Loading room...</div>
      </div>
    );
  }

  if (!room) return <RoomDoesNotExist />;
  // TODO maybe more robust to use a room context instead of prop-drilling this room stuff
  return <Posts room={room} />;
};

export default withRouter(Room);
